import { render, staticRenderFns } from "./OakTable.vue?vue&type=template&id=3bcbf91a&scoped=true"
import script from "./OakTable.vue?vue&type=script&lang=js"
export * from "./OakTable.vue?vue&type=script&lang=js"
import style0 from "./OakTable.vue?vue&type=style&index=0&id=3bcbf91a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcbf91a",
  null
  
)

export default component.exports